<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 400 265" enable-background="new 0 0 400 265" xml:space="preserve">
<path fill="#311E02" opacity="1.000000" stroke="none" 
	d="
M0.999998,244.000000 
	C1.000000,170.645767 1.000000,97.291542 1.315216,23.347099 
	C6.515778,13.918305 12.741629,6.436474 22.262300,2.248284 
	C22.621696,2.090185 22.759132,1.427532 23.000000,1.000000 
	C141.354233,1.000000 259.708466,1.000000 378.652893,1.315222 
	C387.968719,6.626801 395.755951,12.548539 399.752777,22.260483 
	C399.899780,22.617592 400.572357,22.758392 401.000000,22.999998 
	C401.000000,96.354225 401.000000,169.708450 400.684753,243.652863 
	C395.485809,253.083420 389.256134,260.561493 379.737152,264.751373 
	C379.377838,264.909546 379.240662,265.572357 379.000000,266.000000 
	C260.645782,266.000000 142.291550,266.000000 23.347139,265.684753 
	C14.032504,260.372070 6.243085,254.452484 2.247135,244.739609 
	C2.100218,244.382492 1.427614,244.241638 0.999998,244.000000 
M201.687729,211.882690 
	C202.400223,211.839600 203.112717,211.796509 204.333511,212.246033 
	C237.647751,236.862213 279.756317,239.460358 314.182312,219.023834 
	C348.223877,198.815552 366.537354,159.863098 360.880737,119.696976 
	C353.232544,65.389229 302.766388,26.934965 248.240768,34.204468 
	C230.612366,36.554726 214.564453,43.109348 200.330383,55.115261 
	C199.648972,55.178940 198.967575,55.242615 197.754395,54.816628 
	C197.221481,54.416965 196.694336,54.009369 196.154846,53.618778 
	C163.208694,29.765230 120.061661,27.837835 86.600929,48.723461 
	C51.927044,70.366325 34.465431,110.091545 41.778812,150.693893 
	C51.346233,203.810226 100.316460,239.878845 153.713654,232.798218 
	C171.359604,230.458298 187.407440,223.889221 201.687729,211.882690 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M22.531218,1.000000 
	C22.759132,1.427532 22.621696,2.090185 22.262300,2.248284 
	C12.741629,6.436474 6.515778,13.918305 1.315216,22.878443 
	C1.000000,15.740432 1.000000,8.480865 1.000000,1.000000 
	C8.019269,1.000000 15.040852,1.000000 22.531218,1.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M379.468750,266.000000 
	C379.240662,265.572357 379.377838,264.909546 379.737152,264.751373 
	C389.256134,260.561493 395.485809,253.083420 400.684753,244.121521 
	C401.000000,251.259567 401.000000,258.519135 401.000000,266.000000 
	C393.980743,266.000000 386.959137,266.000000 379.468750,266.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M401.000000,22.531216 
	C400.572357,22.758392 399.899780,22.617592 399.752777,22.260483 
	C395.755951,12.548539 387.968719,6.626801 379.121582,1.315222 
	C386.259583,1.000000 393.519135,1.000000 401.000000,1.000000 
	C401.000000,8.019269 401.000000,15.040852 401.000000,22.531216 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M0.999998,244.468781 
	C1.427614,244.241638 2.100218,244.382492 2.247135,244.739609 
	C6.243085,254.452484 14.032504,260.372070 22.878483,265.684753 
	C15.740432,266.000000 8.480864,266.000000 1.000000,266.000000 
	C1.000000,258.980743 1.000000,251.959152 0.999998,244.468781 
z"/>
<path fill="#F69E1B" opacity="1.000000" stroke="none" 
	d="
M201.009964,55.012844 
	C214.564453,43.109348 230.612366,36.554726 248.240768,34.204468 
	C302.766388,26.934965 353.232544,65.389229 360.880737,119.696976 
	C366.537354,159.863098 348.223877,198.815552 314.182312,219.023834 
	C279.756317,239.460358 237.647751,236.862213 204.294556,211.749695 
	C206.617874,208.909042 208.990738,206.575333 211.340714,204.218765 
	C230.715439,184.789810 240.038940,160.955856 239.683517,133.920883 
	C239.261856,101.849335 225.921661,75.425453 201.009964,55.012844 
z"/>
<path fill="#EA001B" opacity="1.000000" stroke="none" 
	d="
M200.977448,211.992691 
	C187.407440,223.889221 171.359604,230.458298 153.713654,232.798218 
	C100.316460,239.878845 51.346233,203.810226 41.778812,150.693893 
	C34.465431,110.091545 51.927044,70.366325 86.600929,48.723461 
	C120.061661,27.837835 163.208694,29.765230 196.154846,53.618778 
	C196.694336,54.009369 197.221481,54.416965 197.812408,55.321968 
	C193.243057,60.606522 188.173309,65.034645 184.057892,70.220169 
	C149.297516,114.019058 156.856369,176.725784 200.977448,211.992691 
z"/>
<path fill="#FF5F00" opacity="1.000000" stroke="none" 
	d="
M201.332581,211.937683 
	C156.856369,176.725784 149.297516,114.019058 184.057892,70.220169 
	C188.173309,65.034645 193.243057,60.606522 198.078308,55.566799 
	C198.967575,55.242615 199.648972,55.178940 200.670166,55.064053 
	C225.921661,75.425453 239.261856,101.849335 239.683517,133.920883 
	C240.038940,160.955856 230.715439,184.789810 211.340714,204.218765 
	C208.990738,206.575333 206.617874,208.909042 204.040405,211.503387 
	C203.112717,211.796509 202.400223,211.839600 201.332581,211.937683 
z"/>
</svg>